import { I18VENTGAINE_State } from '@batical/types/src'

const I18VENTGAINE: I18VENTGAINE_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_debitGaine: 200.0,
  in_pressionAtmospherique: 1013.0,
  rugosite_uuid: '1',
  in_vitesse: 5.0,
  in_mode_gaine: 0,
  res_masseVolAir: 0.0,
  res_viscCine: 0.0,
  res_dnEquivalent: 0.0,
  res_grandcote: 0.0,
  res_petitcote: 0.0,
  res_vitesseReel: 0.0,
  res_pdcLinaire: 0.0,
  perteCharg_uuid: 'F39DD738-5619-43FD-95A8-C1B645ACAED7',
  mode: 'none',
  calcul_code: 'I18VENTGAINE',
  selected_tube: '',
  dataChart: []
}

export default I18VENTGAINE
